import CestService from "@/services/CestService";

export const cest = {
  namespaced: true,
  state: {
    cest: {},
  },
  actions: {
    getCest({ commit }, payload) {
      return CestService.GetCest(payload).then(
        (cest) => {
          return Promise.resolve(cest);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCest({ commit }, payload) {
      return CestService.PostCest(payload).then(
        (cest) => {
          return Promise.resolve(cest);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCest({ commit }, payload) {
      return CestService.PutCest(payload).then(
        (cest) => {
          return Promise.resolve(cest);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCest({ commit }, payload) {
      return CestService.DeleteCest(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCestOData({ commit }, payload) {
      return CestService.GetCestOData(payload).then(
        (cest) => {
          return Promise.resolve(cest);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default cest;
